import styled from 'styled-components';

export const Wrapper = styled.div`
  display: block;
  position: relative;
  margin: 5px;
  width: ${({ width }) => (width || 'initial')};
`;

export const FirstItem = styled.div`
  display: flex;
  background-color: ${({ disabled }) => (disabled ? 'lightgray' : '#0099cc')};
  border-width: 0;
  border-radius: 5px;
  color: ${({ disabled }) => (disabled ? 'darkgray' : '#fff')};
  cursor: pointer;
  font-size: 15px;
  line-height: 28px;
  min-height: 30px;
  padding: 0;
  text-align: center;
  overflow: hidden;
  align-items: stretch;

  :hover{
    background-color: ${({ disabled }) => (disabled ? 'lightgray' : '#0099cc')};
    color: ${({ disabled }) => (disabled ? 'darkgray' : '#fff')};
  }
`;

export const Title = styled.span`
  text-align: left;
  padding-left: 20px;
  padding-right: 10px;
  flex: 1;
`;

export const DropDownIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  float: right;
  width: 30px;
  border-left: 3px solid white;
  line-height: 30px;
`;

export const ItemsList = styled.ul`
  margin: 10px 0;
  background: white;
  border-radius: 3px;
  border: 1px solid #d8d8d8;
  box-shadow: 5px 5px 20px -5px #d8d8d8;
  list-style: none;
  padding: 10px 0;
  overflow: hidden;
  position: ${({ overlap }) => (overlap ? 'absolute' : 'static')};
  left: 0;
  width: 100%;
  z-index: 5;
  white-space: pre-line;

  > * {
    color: #073142;
    cursor: pointer;
    display: block;
    font-size: 15px;
    line-height: 28px;
    padding: 0 20px;
    text-align: left;
    text-decoration: none;

    :hover {
      background-color: #0099cc;
      color: white;
    }
  }
`;
export const StyledItemList = styled(ItemsList)`
  border-radius: 15px;
  padding: 10px 10px 10px 38px;
`;
